<template>
    <BreadCrumb PageTitle="Liste de règles" />
    <ListeRule />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeRule from "@/components/Rules/ListeRule.vue";

export default defineComponent({
    name: "ListeRulePage",
    components: {
        BreadCrumb,
        ListeRule,
    },
});
</script>